// import i18n from '@/i18n/index'

export default {
  test: 'dd',
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'avatar',
    label: '',
    img: true,
    width: '120'
  }, {
    prop: 'phone_number',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'email',
    label: '',
    Object: 'value',
    width: '120'
  },
  // {
  //   prop: 'client_member',
  //   label: '',
  //   Object: 'value',
  //   width: '120'
  // }
  // {
  //   prop: 'birthday',
  //   label: '',
  //   Object: 'value',
  //   width: '120'
  // }
  {
    prop: 'total_due',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'due_date',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'credit_limit',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'wallet_amount',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'active',
    label: '',
    Object: 'value',
    width: '80'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '160'
  }]
}
